export default "__VITE_ASSET__Cdv90xWw__"